import { render, staticRenderFns } from "./simple-report-page.vue?vue&type=template&id=6ba573e3&"
import script from "./simple-report-page.vue?vue&type=script&lang=js&"
export * from "./simple-report-page.vue?vue&type=script&lang=js&"
import style0 from "./simple-report-page.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports